import React from 'react'
import {
  PendencyCard,
  PendencyCardProps,
  PendencyCardRow
} from './components'
import * as icons from '~/assets/icons'

export type Icons = keyof typeof icons

export type AccountPendencyCardRowProps = {
  rowTitle: string,
  firstCardProps: PendencyCardProps,
  secondCardProps: PendencyCardProps
}

export const AccountPendencyCardRow: React.FC<AccountPendencyCardRowProps> = (props) => {
  const { rowTitle, firstCardProps, secondCardProps } = props

  return (
    <PendencyCardRow title={rowTitle}>
      <PendencyCard {...firstCardProps} />
      <PendencyCard {...secondCardProps} />
    </PendencyCardRow>
  )
}
